export default __webpack_public_path__ + "static/media/Boledo.6338ddc3.jpeg";